import { UserType } from "@prisma/client";

// HIPAA automatic logoff (45 CFR §164.312(a)(2)(iii)): an admin session that
// sees no real user activity for this long is signed out by the server.
export const STAFF_IDLE_LOGOFF_S = 2 * 60 * 60;

// Therapists often run back-to-back sessions, so they get a full working day.
export const THERAPIST_IDLE_LOGOFF_S = 8 * 60 * 60;

// School workers get a much longer limit for now, to keep the rollout from
// disrupting counselors. Matches the 30-day rolling session.
export const SCHOOL_WORKER_IDLE_LOGOFF_S = 30 * 24 * 60 * 60;

// The user types the logoff can apply to. Portal users (students and
// guardians) keep their own 1-hour session and are never idle-logged-off.
export const IDLE_LOGOFF_USER_TYPES: readonly UserType[] = [
  UserType.ADMIN,
  UserType.THERAPIST,
  UserType.SCHOOL_WORKER,
];

// The idle limit for each of those user types, in seconds.
export const IDLE_LOGOFF_S_BY_USER_TYPE: Partial<Record<UserType, number>> = {
  [UserType.ADMIN]: STAFF_IDLE_LOGOFF_S,
  [UserType.THERAPIST]: THERAPIST_IDLE_LOGOFF_S,
  [UserType.SCHOOL_WORKER]: SCHOOL_WORKER_IDLE_LOGOFF_S,
};

// Comma-separated user types the logoff is on for, e.g. "ADMIN,THERAPIST".
// Unset or empty means off. Set per stage in stacks/config.ts.
export const IDLE_LOGOFF_USER_TYPES_ENV = "STAFF_IDLE_LOGOFF_USER_TYPES";

// How long before the logoff the "Stay signed in" warning opens.
export const IDLE_LOGOFF_WARNING_S = 2 * 60;

// The most often a tab reports real input to the server.
export const IDLE_ACTIVITY_REPORT_INTERVAL_S = 5 * 60;

// The useSession().update() payload key that marks a report of real input.
export const IDLE_ACTIVITY_UPDATE_KEY = "idleLogoffActivity";

// Browser events that count as the user being at the keyboard.
export const IDLE_ACTIVITY_EVENTS = [
  "pointerdown",
  "pointermove",
  "keydown",
  "wheel",
  "touchstart",
] as const;

// A therapist's appointment page counts as a live session from this long
// before its start to this long after its end, covering a Zoom call that
// runs in another window.
export const IDLE_LOGOFF_LIVE_WINDOW_BEFORE_S = 15 * 60;
export const IDLE_LOGOFF_LIVE_WINDOW_AFTER_S = 30 * 60;
